import rangeSelectors from './range-selectors';
import styleBoxes from './style-boxes';
import assetClass from './asset-class';
import productType from './product-type';
import presetCategories from './preset-categories';
import creditRating from './credit-rating';

export const rangeSelectorModels = rangeSelectors;
export const styleBoxModels = styleBoxes;
export const assetClassModels = assetClass;
export const productTypeModels = productType;
export const presetCategoryModels = presetCategories;
export const creditRatingModels = creditRating;
